import React, { useEffect, useState } from "react";
import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { api } from "../lib/api";

export default function Sparkline() {
  const [weeks, setWeeks] = useState([]);

  useEffect(() => {
    api.get("/progress/sparkline").then((r) => setWeeks(r.data.weeks || [])).catch(() => {});
  }, []);

  const total = weeks.reduce((s, w) => s + w.drills, 0);
  const totalAn = weeks.reduce((s, w) => s + w.analyses, 0);

  return (
    <div data-testid="sparkline-card" className="border border-neutral-800 rounded-md bg-neutral-900 p-6">
      <div className="flex items-baseline justify-between mb-3">
        <div>
          <div className="uppercase text-xs text-neutral-400 font-display tracking-widest">Last 5 weeks</div>
          <div className="mt-1 font-display-heavy text-3xl">
            {total} <span className="text-neutral-500 text-lg font-normal">drills · {totalAn} reps</span>
          </div>
        </div>
      </div>
      <div className="h-32 -mx-2">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={weeks} margin={{ top: 4, right: 8, bottom: 0, left: -20 }}>
            <CartesianGrid stroke="#262626" strokeDasharray="3 3" vertical={false} />
            <XAxis dataKey="label" tick={{ fill: "#888", fontSize: 11 }} tickLine={false} axisLine={{ stroke: "#333" }} />
            <YAxis allowDecimals={false} tick={{ fill: "#888", fontSize: 11 }} tickLine={false} axisLine={{ stroke: "#333" }} width={30} />
            <Tooltip contentStyle={{ background: "#0a0a0a", border: "1px solid #333", borderRadius: 4, color: "#fff" }} labelStyle={{ color: "#aaa" }} />
            <Line type="monotone" dataKey="drills" stroke="#dc2626" strokeWidth={2.5} dot={{ fill: "#dc2626", r: 4 }} name="Drills" />
            <Line type="monotone" dataKey="analyses" stroke="#22c55e" strokeWidth={2} dot={{ fill: "#22c55e", r: 3 }} name="Reps" />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
